import React, { useState } from 'react';
import Layout from '../../Components/Layout.jsx';
import { 
  Box, 
  Typography, 
  Tabs, 
  Tab, 
  Paper
} from '@mui/material';
import { 
  Language as LanguageIcon,
  Storage as StorageIcon,
  BatchPrediction as BatchPredictionIcon
} from '@mui/icons-material';
import KnowledgeBase from './KnowledgeBase.js';
import MCPServers from './MCPServers.js';
import LanguageSettings from './components/LanguageSettings.jsx';

// Tab Panel component
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`agent-tabpanel-${index}`}
      aria-labelledby={`agent-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function Agent() {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };



  return (
    <Layout>
      <Box sx={{ maxWidth: 1200, mt: 3, px: { xs: 0, sm: 2 } }}>
        {/* Header */}
        <Box sx={{ mb: 3, px: { xs: 2, sm: 0 } }}>
          <Typography variant="h5" sx={{ 
            fontWeight: 700, 
            mb: 1,
            fontSize: { xs: '1.5rem', sm: '2rem' },
            color: '#111827'
          }}>
            Agent Management
          </Typography>
          <Typography variant="body2" sx={{ 
            color: '#6b7280',
            fontSize: { xs: '14px', sm: '16px' },
            lineHeight: 1.5
          }}>
            Manage your AI agent's knowledge base and MCP servers
          </Typography>
        </Box>

        {/* Tabs */}
        <Paper sx={{ width: '100%', mb: 2, mx: { xs: 0, sm: 0 } }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs 
              value={tabValue} 
              onChange={handleTabChange}
              aria-label="agent management tabs"
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                '& .MuiTab-root': {
                  textTransform: 'none',
                  fontWeight: 600,
                  fontSize: { xs: '12px', sm: '14px' },
                  minHeight: { xs: '40px', sm: '48px' },
                  px: { xs: 1, sm: 2 },
                  minWidth: { xs: 'auto', sm: 'auto' }
                },
                '& .Mui-selected': {
                  color: '#374151'
                },
                '& .MuiTabs-scrollButtons': {
                  display: { xs: 'flex', sm: 'none' }
                }
              }}
            >
              <Tab 
                icon={<BatchPredictionIcon sx={{ fontSize: { xs: 18, sm: 20 } }} />} 
                label="Knowledge Base" 
                iconPosition="start"
              />
              <Tab 
                icon={<LanguageIcon sx={{ fontSize: { xs: 18, sm: 20 } }} />} 
                label="Language" 
                iconPosition="start"
              />
              <Tab 
                icon={<StorageIcon sx={{ fontSize: { xs: 18, sm: 20 } }} />} 
                label="MCP Servers" 
                iconPosition="start"
              />
            </Tabs>
          </Box>
        </Paper>

        {/* Tab Panels */}
        <TabPanel value={tabValue} index={0}>
          <KnowledgeBase />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <LanguageSettings />
        </TabPanel>

        <TabPanel value={tabValue} index={2}>
          <MCPServers />
        </TabPanel>
      </Box>
    </Layout>
  );
}

export default Agent;
